import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _ModesVertHorCustom(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", d: "M7.5 12.5H3M22 12.5h-4.5" }),
            React.createElement("circle", { cx: 12.5, cy: 12.5, r: 4.5, stroke: "currentColor", transform: "rotate(90 12.5 12.5)" })));
}
const ModesVertHorCustom = forwardRef(_ModesVertHorCustom);
export { ModesVertHorCustom };
